export default __webpack_public_path__ + "static/media/GitHub-Mark.bfdd4b5a.svg";